<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
    /*@import 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css';*/

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    padding: 0;
    margin: 0;
    font-size: 0;

    --brown_j: #a37e74;
    --height-top-bar: 20vh;
    --height-top-bar_cats: 4vh;

    /*********** menu icon *************/
    --menu-icon-width_small: 2vh;
    --menu-icon-width: 3vh;
    --menu-icon-height: 0.2vh;
    --menu-icon-spacing: 1.1vh;
    --menu-icon-top: 2vh;
    --menu-icon-top_desk: 5.3vh;
    --menu-icon-margin-left: 0.8vw;
    --menu-icon-color: #111;

    /*--side-bar-color: #996515;*/
    /*--side-bar-color_trans: #996515BB;*/
    /*--side-bar-color: #DAA520;*/
    /*--side-bar-color_trans: #DAA520BB;*/

    --side-bar-color: #a37e74;
    --side-bar-color_trans: #a37e74BB;

    /* Resgister Product Advice */
    --main-bg-color: black;
    --font-dark-gray2: #606062;
    --bg-purple: #a22dc9;
    --bg-blue: #0f62ac;
    --bg-lightgray: #f2f2f2;
}

@font-face {
    font-family: 'Font1_Bold'; /*a name to be used later*/
    src: url('/src/assets/fonts/font1_b.woff2') format('woff2'); /*URL to font*/
}
@font-face {
    font-family: 'Font1_Normal'; /*a name to be used later*/
    src: url('/src/assets/fonts/font1_n.woff2') format('woff2'); /*URL to font*/
}

@font-face {
    font-family: 'Fonte1'; /*a name to be used later*/
    src: url('/src/assets/fonts/font1_bold.woff2') format('woff2'); /*URL to font*/
}
@font-face {
    font-family: 'Fonte2'; /*a name to be used later*/
    src: url('/src/assets/fonts/font1_normal.woff2') format('woff2'); /*URL to font*/
}

body {
    margin: 0;
    background-color: black;
}

@media screen and (max-width: 999px) {
    #app {
        --height-top-bar: 7vh;
        --height-top-bar_cats: 0vh;
    }
}
@media screen and (min-width: 1000px) {
    #app {

    }
}
@media screen and (min-width: 1400px) {
    #app {

    }
}
@media screen and (min-width: 1600px) {
    #app {

    }
}
@media screen and (min-width: 1900px) {
    #app {

    }
}
@media screen and (min-width: 2200px) {
    #app {

    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue